<p-toast></p-toast>

<div class="dispute-review-page quotation-review-page">
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template pTemplate="start">
                <div class="left-buttons">
                    <h5 class="dispute-toolbar-title">Customer portal draft orders</h5>
                    <p-button
                        label="Refresh"
                        icon="pi pi-refresh"
                        severity="secondary"
                        (onClick)="reload()"
                    ></p-button>
                </div>
            </ng-template>
            <ng-template pTemplate="end">
                <div class="right-buttons">
                    <p-button
                        label="Back to Orders"
                        icon="pi pi-arrow-left"
                        severity="secondary"
                        [routerLink]="['/Orders1']"
                    ></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <app-quotation-kpi-bar
        [stats]="kpiStats"
        [activeFilter]="selectedStatus"
        (filterSelect)="onKpiFilterSelect($event)"
    ></app-quotation-kpi-bar>

    <div class="filters-row">
        <div class="date-range-filter">
            <label class="date-label" for="quoteFromDate">From</label>
            <input
                id="quoteFromDate"
                type="date"
                pInputText
                class="date-input"
                [(ngModel)]="fromDate"
                [max]="toDate"
                (change)="onDateChange()"
            />
            <label class="date-label" for="quoteToDate">To</label>
            <input
                id="quoteToDate"
                type="date"
                pInputText
                class="date-input"
                [(ngModel)]="toDate"
                [min]="fromDate"
                (change)="onDateChange()"
            />
        </div>
        <span class="search-wrap">
            <i class="pi pi-search"></i>
            <input
                pInputText
                type="search"
                placeholder="Search draft order / customer"
                [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchChange()"
            />
        </span>
        <p-select
            [options]="statusOptions"
            [(ngModel)]="selectedStatus"
            optionLabel="label"
            optionValue="value"
            placeholder="Filter"
            (onChange)="onFilterChange()"
        ></p-select>
    </div>

    <section class="list-section">
        <app-quotation-table
            [quotations]="filteredQuotations"
            (view)="openQuotation($event)"
        ></app-quotation-table>
    </section>
</div>
